// @ts-strict-ignore
import React from 'react'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import Flex from '@/shared/ui/Flex'
import { Col, Row } from '@/shared/ui/Grid'

import styles from './DeliveryInfoItem.module.scss'

export type DeliveryInfoItemProps = {
	title?: string
	timeWork?: string
	noteList?: string[]
	description?: string
	dayDeliveryInfoList?: DeliveryInfoDayProps[]
	countryDeliveryInfoList?: DeliveryInfoDayProps[]
	countryDeliveryInfoList2?: DeliveryInfoDayProps[]
	column?: boolean
	note?: string
}

export const DeliveryInfoItem = ({
	title,
	timeWork,
	noteList = [],
	description,
	dayDeliveryInfoList,
	countryDeliveryInfoList,
	countryDeliveryInfoList2,
	column
}: DeliveryInfoItemProps): JSX.Element => (
	<div className={styles.deliveryInfoItem}>
		<Row gutter={[120, 40]}>
			{!!title && (
				<Col lg={!column ? 12 : 24} xs={24}>
					<h4 className={styles.title}>{title}</h4>
					{timeWork && <p className={styles.timeWork}>{timeWork}</p>}
					{description && <p className={styles.description} dangerouslySetInnerHTML={createMarkup(description)} />}
					{!!noteList.length && (
						<>
							{noteList.map(item => (
								<div className={styles.note} key={item} dangerouslySetInnerHTML={createMarkup(item)} />
							))}
						</>
					)}
				</Col>
			)}

			{!!countryDeliveryInfoList2?.length && (
				<Col lg={!column ? 12 : 24} xs={24}>
					<Flex column>
						<>
							{countryDeliveryInfoList2?.map(item => (
								<DeliveryInfoDay key={item.name} {...item} />
							))}
						</>
					</Flex>
				</Col>
			)}

			{!!dayDeliveryInfoList?.length && (
				<Col lg={!column ? 12 : 24} xs={24}>
					<Flex column>
						<>
							{dayDeliveryInfoList?.map(item => (
								<DeliveryInfoDay key={item.name} {...item} />
							))}
						</>
					</Flex>
				</Col>
			)}
			<Col lg={!column ? 12 : 24} xs={24}>
				<Flex column>
					{!!countryDeliveryInfoList?.length && (
						<>
							{countryDeliveryInfoList?.map(item => (
								<DeliveryInfoDay key={item.name} {...item} />
							))}
						</>
					)}
				</Flex>
			</Col>
		</Row>
		<p className={styles.bottomNote}>Данные условия распространяются только на заказы, оформленные онлайн.</p>
	</div>
)

export type DeliveryInfoDayProps = {
	name?: string
	note?: string
	timeWork?: string
	items?: {
		description?: string
		notation?: string
	}[]
	numberList?: boolean
}

export const DeliveryInfoDay = ({ name, items, numberList, note, timeWork }: DeliveryInfoDayProps): JSX.Element => (
	<article className={styles.deliveryInfoDay}>
		<h4 className={styles.dayTitle}>{name}</h4>
		{timeWork && <p className={styles.timeWork}>{timeWork}</p>}
		<ul className={[styles.list, numberList ? styles.list_number : null].filter(Boolean).join(' ')}>
			{items.map(item => (
				<li className={styles.item} key={item.description}>
					<span dangerouslySetInnerHTML={createMarkup(item.description)} />
					{item.notation && <p className={styles.notation} dangerouslySetInnerHTML={createMarkup(item.notation)} />}
				</li>
			))}
			{note && <p className={styles.dayNote}>{note}</p>}
		</ul>
	</article>
)
